<template>
	<v-expansion-panels v-model="panel" flat accordion>
		<ExpansionPanel :title="'Basics'">
			<div>URL</div>
			<CombinedInputFieldDataMenu class="mb-6" :textAreaMode="true" :value.sync="hubSpotLink" :valuesTypes="dataInputMenuValueTypes" />
		</ExpansionPanel>
		<ExpansionPanel :title="'Advanced'">
			<div class="pt-2">Confirmation Handling:</div>
			<AppSelect
				:items="HUBSPOT_SCHEDULER_SETTINGS_CONFIRMATION_OPTIONS"
				outlined
				dense
				placeholder="Automatically proceed to next step with animation"
				item-text="title"
				item-value="value"
				v-model="confirmationHandlingOption"
			></AppSelect>
		</ExpansionPanel>
	</v-expansion-panels>
</template>

<script>
import ItemOnlyAllowedValueTypesMixin from './ValueTypesMixins/ItemOnlyAllowedValueTypesMixin';
import ExpansionPanel from './WidgetSettings/ExpansionPanel';
import { HUBSPOT_SCHEDULER_SETTINGS_CONFIRMATION_OPTIONS } from '../hubspot-scheduler.const';
import FieldSettingsMixin, { getComputedMetadataOption } from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';
import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu';
export default {
	name: 'HubSpotFieldSettings',
	mixins: [FieldSettingsMixin, ItemOnlyAllowedValueTypesMixin],
	components: {
		ExpansionPanel,
		CombinedInputFieldDataMenu,
	},
	computed: {
		metadataOptions() {
			return this.localField.metadata.options;
		},
		confirmationHandlingOption: getComputedMetadataOption('confirmation_handling_option', 'value'),
		hubSpotLink: getComputedMetadataOption('hubspot_link', 'value'),
	},
	data() {
		return {
			HUBSPOT_SCHEDULER_SETTINGS_CONFIRMATION_OPTIONS,
		};
	},
	methods: {},
};
</script>
